import { AlertTriangle } from 'lucide-react'
import { ProjectFileError } from '../project-file'

interface ProjectImportErrorDialogProps {
  error: Error
  onClose: () => void
}

export function ProjectImportErrorDialog({ error, onClose }: ProjectImportErrorDialogProps) {
  const details = error instanceof ProjectFileError ? error.details : []
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="modal import-project-error" role="alertdialog" aria-modal="true" aria-labelledby="project-import-error-title">
        <div className="import-project-error-icon"><AlertTriangle size={22} /></div>
        <span className="modal-kicker">Project import</span>
        <h2 id="project-import-error-title">Unable to open this project</h2>
        <p>{error.message}</p>
        {details.length > 0 && <div className="import-project-error-details"><strong>What Deckelier found</strong><ul>{details.slice(0, 8).map((detail) => <li key={detail}>{detail}</li>)}</ul>{details.length > 8 && <small>Plus {details.length - 8} more validation issue{details.length - 8 === 1 ? '' : 's'}.</small>}</div>}
        <p className="import-project-error-note">The original file was not changed. If this came from another browser, export it again there before deleting anything.</p>
        <div className="modal-actions"><button className="button primary" autoFocus onClick={onClose}>Close</button></div>
      </section>
    </div>
  )
}
